/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutomationStateCondition
 */
export interface AutomationStateCondition {
    /**
     * 
     * @type {string}
     * @memberof AutomationStateCondition
     */
    field: AutomationStateConditionFieldEnum;
    /**
     * 
     * @type {string}
     * @memberof AutomationStateCondition
     */
    operator: AutomationStateConditionOperatorEnum;
    /**
     * Property US state to compare against. Accepts a 2-letter code or full name; canonicalized server-side.
     * @type {string}
     * @memberof AutomationStateCondition
     */
    value: string;
}


/**
 * @export
 */
export const AutomationStateConditionFieldEnum = {
    State: 'state'
} as const;
export type AutomationStateConditionFieldEnum = typeof AutomationStateConditionFieldEnum[keyof typeof AutomationStateConditionFieldEnum];

/**
 * @export
 */
export const AutomationStateConditionOperatorEnum = {
    Eq: 'eq',
    Neq: 'neq'
} as const;
export type AutomationStateConditionOperatorEnum = typeof AutomationStateConditionOperatorEnum[keyof typeof AutomationStateConditionOperatorEnum];


/**
 * Check if a given object implements the AutomationStateCondition interface.
 */
export function instanceOfAutomationStateCondition(value: object): value is AutomationStateCondition {
    if (!('field' in value) || value['field'] === undefined) return false;
    if (!('operator' in value) || value['operator'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AutomationStateConditionFromJSON(json: any): AutomationStateCondition {
    return AutomationStateConditionFromJSONTyped(json, false);
}

export function AutomationStateConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutomationStateCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'field': json['field'],
        'operator': json['operator'],
        'value': json['value'],
    };
}

export function AutomationStateConditionToJSON(json: any): AutomationStateCondition {
    return AutomationStateConditionToJSONTyped(json, false);
}

export function AutomationStateConditionToJSONTyped(value?: AutomationStateCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'field': value['field'],
        'operator': value['operator'],
        'value': value['value'],
    };
}

